import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sbnb-subnav',
  templateUrl: './subnav.component.html',
  styleUrls: ['./subnav.component.scss'],
})
export class SubnavComponent {
  header = input<string>();
  settingsLink = input<string>();

  @HostBinding('class') class = 'hidden lg:flex max-w-[256px] min-w-[256px]';
}
